<template>
  <div class="page-container">
    <header-title
      title="TT Chart"
      @onRefresh="handleFinish"
      has-refresh
    ></header-title>
    <div class="filter-box">
      <a-form layout="inline" :model="form" @finish="handleFinish">
        <a-form-item label="Region">
          <a-select v-model:value="form.regionCodeName" allowClear>
            <a-select-option
              v-for="item in regionList"
              :key="item.name"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit">
            <template #icon><SearchOutlined /></template>
            Find
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-spin :spinning="loading" tip="Loading...">
      <ec-tt-chart
        class="tt-chart-box"
        :tt-x-axis="bar.xAxis"
        :tt-cycle-data="bar.cycleTime"
        :tt-takt-data="bar.taktTime"
      ></ec-tt-chart>
    </a-spin>
  </div>
</template>
<script>
  import HeaderTitle from '@/layout/header-title'
  import { SearchOutlined } from '@ant-design/icons-vue'
  import { getRegionList, getTT } from '@/api/supervisor-landing'
  import EcTtChart from './ec-tt-chart'
  export default {
    components: { HeaderTitle, SearchOutlined, EcTtChart },
    data() {
      return {
        loading: false,
        form: {
          regionCodeName: '',
        },
        regionList: [],
        bar: {
          cycleTime: [],
          taktTime: [],
          xAxis: [],
        },
      }
    },
    watch: {},
    created() {
      this.getRegion()
    },
    methods: {
      async handleFinish() {
        this.loading = true
        const { id, uiid } = this.$route.query
        const params = {
          id,
          uiid,
        }
        if (this.form.regionCodeName) {
          params.regioncode = this.form.regionCodeName
        } else {
          delete params.regioncode
        }
        try {
          const { body } = await getTT(params)
          if (body.cycle && body.cycle.length) {
            let xAxis = [],
              cycleTime = [],
              taktTime = []
            body.cycle.forEach((v) => {
              xAxis.push(v.jobId)
              cycleTime.push(v.val)
              taktTime.push(body.takt)
            })
            this.bar = { xAxis, cycleTime, taktTime }
            this.loading = false
          }
        } catch (e) {
          this.loading = false
        }
      },
      async getRegion() {
        const { id, uiid } = this.$route.query
        const params = {
          id,
          uiid,
        }
        const { body } = await getRegionList(params)
        this.regionList = body
        this.form.regionCodeName = body[0].name || ''
        this.handleFinish()
      },
    },
  }
</script>
<style lang="less" scoped>
  .page-container {
    height: calc(100vh - 32px);
    :deep(.ant-select) {
      width: 200px;
    }
    .tt-chart-box {
      width: 60%;
      margin: 30px auto 0;
      height: calc(100vh - 32px - 40px - 90px);
    }
  }
</style>
